import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { formatCurrency } from './utils';
import { MarginAnalysisState } from './useMarginAnalysis';
interface MetricsSectionProps {
  state: MarginAnalysisState;
}
const MetricsSection: React.FC<MetricsSectionProps> = ({
  state
}) => {
  const {
    actualRevenue,
    cogs,
    grossProfit,
    grossProfitMargin
  } = state;

  // Calculate bar heights (percentage of total space)
  const totalHeight = 200; // Maximum bar height in pixels
  const cogsPercentage = cogs / actualRevenue * 100;
  const grossProfitPercentage = 100 - cogsPercentage;

  // Calculate heights for visualization
  const cogsHeight = cogsPercentage / 100 * totalHeight;
  const grossProfitHeight = grossProfitPercentage / 100 * totalHeight;
  return <Card className="bg-gradient-to-br from-[#1e293b] to-[#111827] border-primary/20 shadow-md hover:shadow-[#6366F1]/10 transition-all duration-300 rounded-md flex-1 h-[297px]">
      <CardContent className="p-4 flex flex-col h-full py-0 px-[22px] my-0">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-[15px] font-semibold text-[#D6BCFA] my-[8px]">Current Gross Profitability</h3>
          
          {/* Gross Profit Margin moved to top right */}
          <div className="bg-black/90 w-[180px] px-2 rounded-md text-[12px]">
            <span className="text-[#10B981] font-medium text-[12px]">
              Gross Profit Margin: {grossProfitMargin.toFixed(2)}%
            </span>
          </div>
        </div>
        
        <div className="flex items-end h-[220px] mt-2 mb-4">
          <div className="flex-1 flex items-end justify-around">
            {/* Revenue Bar */}
            <div className="flex flex-col items-center relative px-0 w-[120px] mx-[18px]">
              <div className="w-16 bg-[#0EA5E9] rounded-t-md relative" style={{
              height: `${totalHeight}px`
            }}>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-0 -translate-y-1/2 bg-black/60 rounded-md whitespace-nowrap py-0 px-0 mx-[8px]">
                  <span className="text-white text-xs font-medium">
                    {formatCurrency(actualRevenue)}
                  </span>
                </div>
              </div>
              <div className="mt-2 text-xs text-gray-300 text-center w-[100px]">Revenue</div>
            </div>

            {/* COGS + Gross Profit Stacked Bar - aligned at the bottom with Revenue */}
            <div className="flex flex-col items-center relative mx-0 px-0 w-[150px]">
              <div className="relative w-16 h-[200px] flex flex-col justify-end">
                {/* Gross Profit Bar on top */}
                <div style={{
                height: `${grossProfitHeight}px`
              }} className="w-full rounded-t-md relative bg-lime-300">
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-0 -translate-y-1/2 bg-black/60 rounded-md whitespace-nowrap my-0 py-0 px-0 mx-[8px]">
                    <span className="text-white text-xs font-medium">
                      {formatCurrency(grossProfit)}
                    </span>
                  </div>
                </div>
                
                {/* COGS Bar at bottom */}
                <div style={{
                height: `${cogsHeight}px`
              }} className="w-full bg-[#ea384c] rounded-t relative">
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-0 -translate-y-1/2 bg-black/60 rounded-md whitespace-nowrap px-0 my-0 py-px mx-[8px]">
                    <span className="text-white text-xs font-medium">
                      {formatCurrency(cogs)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-2 text-xs text-gray-300 text-center w-[180px]">COGS + Gross Profit</div>
            </div>
          </div>
          
          {/* Legend moved to far right */}
          <div className="flex flex-col gap-1 ml-auto">
            <div className="flex items-center">
              <div className="w-3 h-3 bg-[#0EA5E9] mr-2 rounded-sm"></div>
              <span className="text-gray-300 text-[10px]">Revenue</span>
            </div>
            <div className="flex items-center">
              <div className="w-3 h-3 bg-[#ea384c] mr-2 rounded-sm"></div>
              <span className="text-gray-300 text-[10px]">COGS</span>
            </div>
            <div className="flex items-center">
              <div className="w-3 h-3 mr-2 rounded-sm bg-lime-300"></div>
              <span className="text-gray-300 text-[10px]">Gross Profit</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>;
};
export default MetricsSection;